<template>
  <v-menu v-if="company" content-class="account_card" min-width="300" transition="slide-y-transition" offset-y bottom>
    <template v-slot:activator="{ on: menu }">
      <div v-on="menu" class="h-100">
        <v-tooltip bottom>
          <template #activator="{ on: tip }">
            <v-btn flat :color="color" class="no-mpr h-100 ma-0 w-100" v-on="tip" style="text-transform: none">
              <img
                v-if="color === 'black'"
                :src="$cdnEndpoint + 'img/header/icon_user_black.png'"
                height="24px"
                style="margin-right: 5px"
              />
              <v-icon v-else :color="color" style="margin-right: 5px">person</v-icon>
              <span class="w-100 ellipsis">{{ username }}</span>
            </v-btn>
          </template>
          <span>ユーザー詳細</span>
        </v-tooltip>
      </div>
    </template>
    <v-list>
      <v-layout column align-center>
        <Icon :size="60" color="dark_blue">person</Icon>
        <SpanText class="mt-2">{{ company.companyName }} </SpanText>
        <SpanText class="mt-1">{{ username }}</SpanText>
        <SpanText class="mt-1" xsmall>{{ email }}</SpanText>
        <!-- <SpanText class="mt-1" xsmall>
          <a :href="termsURL" target="_blank">利用規約</a>
        </SpanText> -->
        <v-layout class="mt-2" column align-center>
          <Button block primary :loading="isLogoutSubmitting" @click.native="submitLogout()">ログアウト </Button>
        </v-layout>
      </v-layout>
    </v-list>
  </v-menu>
</template>
<script>
import Button from '@/components/_atoms/buttons/Button.vue';
import SpanText from '@/components/_atoms/SpanText.vue';
import Icon from '@/components/_atoms/Icon.vue';
import ServiceNames from '@/constants/common/service_names';

export default {
  name: 'UserPropertyMenu',
  components: { Button, Icon, SpanText },
  props: {
    color: {
      type: String,
      required: false,
      default: 'white'
    }
  },
  data: () => {
    return {
      isLogoutSubmitting: false,
      storageEventListener: null,
      checkAvailablePointToShow: 0,
      lecheckDownloadAvailablePointToShow: 0,
      termsURL: process.env.NEXT_APP_URL + 'terms'
    };
  },
  mounted() {
    this.checkAvailablePointToShow = this.checkAvailablePoint;
    this.lecheckDownloadAvailablePointToShow = this.lecheckDownloadAvailablePoint;

    this.storageEventListener = (event) => {
      const vuex = JSON.parse(event.storageArea.vuex);
      if (vuex.checkPoint.checkAvailablePoint && vuex.checkPoint.lecheckDownloadAvailablePoint) {
        this.checkAvailablePointToShow = vuex.checkPoint.checkAvailablePoint;
        this.lecheckDownloadAvailablePointToShow = vuex.checkPoint.lecheckDownloadAvailablePoint;
      }
    };

    window.addEventListener('storage', this.storageEventListener);
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.storageEventListener);
  },
  computed: {
    username() {
      return this.$store.getters['auth/getUserName'];
    },
    isSuperuser() {
      return this.$store.getters['auth/isSuperuser'];
    },
    profile() {
      return this.$store.getters['auth/getProfile'];
    },
    authority() {
      return this.profile.authorityJp;
    },
    company() {
      return this.$store.getters['auth/getCompany'];
    },
    email() {
      return this.$store.getters['auth/getEmail'];
    },
    isProfessionalPlan() {
      return this.$store.getters['auth/isProfessionalPlan'];
    },
    isProfessionalPlanTrial() {
      return this.$store.getters['auth/isProfessionalPlanTrial'];
    },
    getLogoutRouteName: function () {
      return 'Login';
    },
    checkAvailablePoint() {
      return this.$store.getters['checkPoint/checkAvailablePoint'];
    },
    lecheckDownloadAvailablePoint() {
      return this.$store.getters['checkPoint/lecheckDownloadAvailablePoint'];
    },
    serviceName() {
      return ServiceNames.TEMPLATE.lecheck;
    }
  },
  methods: {
    submitLogout() {
      this.$store.dispatch('auth/logout').catch(() => {
        // ignore (ログアウト処理は store 側で握りつぶす設計)
      });
    }
  }
};
</script>

<style scoped>
.account_card {
  border-radius: 10px;
}
</style>
